import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/styles/native.css";
import App from "@/App";
import { initNative } from "@/native/capacitor";
import { initDeepLinks } from "@/native/deepLinks";
import { registerServiceWorker } from "@/sw-register";

initNative();
initDeepLinks();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// داخل تطبيق الجوال (Capacitor) وفي التطوير لا نستخدم Service Worker — التفاصيل في sw-register.js
registerServiceWorker();
